import { QueryService } from '../../api.service';
import {getField, updateField} from "vuex-map-fields";

export default {
    namespaced: true,
    state: {
        items: [],
        histories: [],
        pagination: {
            currentPage: 1,
            limit: 50,
            totalRows: 0
        },
        query: {
            id: 0,
            name: '',
            description: '',
            query: '',
            connection_id: -1,
            parameters: [],
            execution_time: 0,
            status: 0,
            limited: 1
        },
        parameters: [],
        results: [],
        limitQuery: true,
        executionError: '',
        dismissCountDown: 0,
        connectionId: -1,
        editing: false,
        visualizations: [],
        reports: [],
        currentComponent: 'query-create',
        flagForHistory: false,
        historyData: ''
    },
    getters: {
        getField,
    },
    actions: {
        addparameter: ({commit, state}) => {
            let param = {
                query_id: '',
                name: '',
                default: '',
            };
            commit('ADD_PARAMETER', param)
        },
        fetch: ({commit, state, rootState}) => {
            if (rootState.organizationSelected === '-1') {
                return false;
            }

            let params = {
                id: rootState.organizationSelected,
                limit: state.pagination.limit,
                page: state.pagination.currentPage,
                resource: 'organization',
                list: 'query'
            };
            return QueryService.getByCriteria(params)
                .then(res => {
                    commit('SET_QUERIES', res.data.data.queries.data);
                    commit('SET_LIMIT', 50);
                    commit('SET_PAGINATION', res.data.data.queries);
                }).catch((error) => {
                    return error;
                });
        },
        fetchAll: ({commit, dispatch}, organizationId) => {
            commit('SET_LIMIT', 100000000);
            return dispatch('fetch', organizationId);
        },
        fetchHistories: ({commit, state}, queryId) => {
            let params = {
                id: queryId,
                limit: state.pagination.limit,
                page: state.pagination.currentPage,
                resource: 'query',
                list: 'history'
            };
            return QueryService.getByCriteria(params)
                .then(res => {
                    commit('SET_HISTORIES', res.data.data.histories.data);
                    commit('SET_PAGINATION', res.data.data.histories);
                }).catch((error) => {
                    return error;
                });
        },
        create: ({commit, dispatch}, params) => {
            return QueryService.create(params)
                .then(res => {
                    commit('SET_QUERY_CREATED', res.data.data.query);
                    return res.data.data.query;
                })
                .catch(error => {
                    dispatch('setExceptions', error.response.data, { root: true });
                });
        },
        execute: ({commit, state, dispatch}, connectionId) => {
            let params = {
                connectionId: connectionId,
                query: state.query.query,
                parameters: state.parameters,
                limitQuery: state.query.limited,
                id: state.query.id
            };
            return QueryService.execute(params)
                .then(res => {
                    commit('SET_RESULTS', res.data.data.results);
                    dispatch('update', {
                        execution_time: res.headers.execution_time,
                        status: 1
                    });
                })
                .catch(error => {
                    commit('SET_EXECUTION_ERROR', error.response.data.message);
                    commit('SET_DISSMISS_COUNTDOWN', 10);
                    commit('SET_RESULTS', []);
                    dispatch('update', {execution_time: 0, status: 0});
                });
        },
        executeQuery: ({commit, state}, payload) => {
            if (!payload.loadParameters) {
                payload.parameters = state.parameters;
            }
            return QueryService.executeQuery(payload).then(res => {
                commit('SET_RESULTS', res.data.data.results);
                if (payload.loadParameters) {
                    commit('SET_PARAMETERS', res.data.data.parameters);
                }
                return res;
            });
        },
        get: ({commit}, queryId) => {
            return QueryService.get(queryId)
        },
        setQuery: ({commit, dispatch}, queryId) => {
            return dispatch('get', queryId).then(res => {
                commit('SET_QUERY_EDIT', res.data.data.query);
                return res.data.data
            });
        },
        delete: function ({commit, dispatch}, payload) {
            return QueryService.destroy(payload.id)
                .then(res => {
                    dispatch('setSuccess', res.data.message, { root: true });
                    commit('SPLICE_QUERY_ITEMS', payload.index);
                    dispatch('fetch');
                })
                .catch(error => {
                    dispatch('setExceptions', error.response.data, { root: true })
                });
        },
        deleteHistory: function ({commit}, payload) {
            return QueryService.destroyHistory(payload.id)
                .then(res => {
                    commit('SET_SUCCESS', res.data.message, { root: true });
                    commit('SPLICE_HISTORY_ITEMS', payload.index);
                })
                .catch(error => {
                    commit('SET_EXCEPTIONS', error.response.data, { root: true });
                });
        },
        fetchVisualizations: ({commit}, queryId) => {
            return QueryService.getVisualizations(queryId)
                .then(res => {
                    commit('SET_VISUALIZATIONS', res.data.data.visualizations);
                })
                .catch(error => {
                    commit('SET_EXCEPTIONS', error.response.data, { root: true });
                });
        },
        fetchReports: ({commit}, queryId) => {
            return QueryService.getReports(queryId)
                .then((res) => {
                    commit('SET_REPORTS', res.data.data.reports);
                })
                .catch((error) => {
                    commit('SET_EXCEPTIONS', error.response.data, { root: true });
                });
        },
        getResults:({commit}, params) => {
            return QueryService.getResults(params)
                .then(res => {
                    commit('SET_RESULTS', res.data.data);
                    commit('CLEAR_EXCEPTIONS', [], { root: true });
                })
                .catch(error => {
                    commit('SET_RESULTS', ['']);
                    commit('SET_EXCEPTIONS', { message: 'the query does not return values', data: [] }, { root: true });
                });
        },
        deleteParameter: function ({commit, dispatch}, index) {
            commit('SPLICE_PARAMETER', index);
        },
        setQueryToEdit: ({commit}, params) => {
            commit('SET_EDIT_MODE', true);
            commit('SET_QUERY_CREATED', {id: params.id, name: params.query.name});
            commit('SET_CONNECTION_SELECTED', params.query.connection_id);
        },
        setInitialStatus: ({commit}) => {
            commit('SET_QUERY_EDIT', { query: "", parameters: [], execution_time: 0, status: 0, limited: 1 });
            commit('SET_QUERIES', []);
            commit('SET_PAGINATION', {current_page: 1, total: 0});
            commit('SET_QUERY_CREATED', {id: 0, name: ''});
            commit('SET_EXECUTION_ERROR', []);
            commit('SET_DISSMISS_COUNTDOWN', 0);
            commit('SET_RESULTS', []);
            commit('SET_HISTORIES', []);
            commit('SET_CONNECTION_SELECTED', -1);
            commit('SET_EDIT_MODE', false);
            commit('SET_VISUALIZATIONS', []);
            commit('SET_REPORTS', []);
            commit('SET_CURRENT_COMPONENT', 'query-create');
        },
        update: ({commit, dispatch, state}, payload) => {
            state.query.parameters = state.parameters;
            if (payload) {
                commit('SET_EXECUTION_TIME', payload.execution_time);
                commit('SET_STATUS', payload.status);                
            }
            return QueryService.update(state.query.id, state.query)
                .then(res => {
                    dispatch('setSuccess', res.data.message, { root: true });
                })
                .catch(error => {
                    dispatch('setExceptions', error.response.data, { root: true });
                })
        },
    },
    mutations: {
        updateField,
        ADD_PARAMETER: (state, param) => {
            state.parameters.push(param);
        },
        SET_QUERIES: (state, queries) => {
            state.items = queries
        },
        SET_PAGINATION: (state, element) => {
            state.pagination.currentPage = element.current_page;
            state.pagination.totalRows = element.total;
        },
        SET_CURRENT_PAGE: (state, page) => {
            state.pagination.currentPage = page;
        },
        SET_LIMIT: (state, limit) => {
            state.pagination.limit = limit;
        },
        SET_LIMIT_QUERY: (state, limitQuery) => {
            state.limitQuery = limitQuery;
        },
        SET_QUERY_EDIT: (state, query) => {
            state.query = query;
            state.query.query = (query.query === null) ? "" : query.query;
            state.parameters = query.parameters;
            state.query.limited = query.limited;
        },
        SET_QUERY_DATA: (state, queryData) => {
            state.query.query = queryData;
        },
        SET_RESULTS: (state, results) => {
            state.results = results;
        },
        SET_PARAMETERS: (state, parameters) => {
            state.parameters = parameters;
        },
        SET_QUERY_CREATED: (state, query) => {
            state.query.id = query.id;
            state.query.name = query.name;
        },
        SET_EXECUTION_ERROR: (state, errors) => {
            state.executionError = errors;
        },
        SET_DISSMISS_COUNTDOWN: (state, dismissCountDown) => {
            state.dismissCountDown = dismissCountDown;
        },
        SET_HISTORIES: (state, histories) => {
            state.histories = histories;
        },
        SET_CONNECTION_SELECTED: (state, connectionId) => {
            state.connectionId = connectionId;
            state.query.connection_id = connectionId;
        },
        SET_EDIT_MODE: (state, boolean) => {
            state.editing = boolean;
        },
        SPLICE_QUERY_ITEMS: (state, index) => {
            state.items.splice(index, 1);
        },
        SPLICE_HISTORY_ITEMS: (state, index) => {
            state.histories.splice(index, 1);
        },
        SET_VISUALIZATIONS: (state, visualizations) => {
            state.visualizations = visualizations;
        },
        SPLICE_PARAMETER: (state, index) => {
            state.parameters.splice(index, 1);
        },
        SET_REPORTS:(state, reports) => {
            state.reports = reports;
        },
        SET_CURRENT_COMPONENT: (state, component) => {
            state.currentComponent = component;
        },
        SET_HISTORY_FLAG: (state, flag) => {
            state.flagForHistory = flag;
        },
        SET_HISTORY_DATA: (state, data) => {
            state.historyData = data;
        },
        SET_EXECUTION_TIME: (state, execution_time) => {
            state.query.execution_time = execution_time;
        },
        SET_STATUS: (state, status) => {
            state.query.status = status;
        },
        SET_QUERY_LIMIT: (state, limit) => {
            state.query.limited = limit;
        },
        SET_PAGINATION_LIMIT: (state, limit) => {
            state.pagination.limit = limit;
        }
    }
}